/* WhataHoot OS — small, dependency-free behaviour for the wah-os-* sections.
   Every block is optional: it only runs when its markup is on the page. */
(() => {
  document.documentElement.classList.add('wos-js');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---------- Header: mega menus (hover on desktop, click/keyboard everywhere)
  function initNav() {
    const items = $$('.wos-nav > li[data-mega]');
    let closeTimer;
    const closeAll = (except) => items.forEach((li) => {
      if (li === except) return;
      li.classList.remove('is-open');
      li.querySelector('.wos-nav__top')?.setAttribute('aria-expanded', 'false');
    });
    items.forEach((li) => {
      const btn = li.querySelector('.wos-nav__top');
      const open = () => { clearTimeout(closeTimer); closeAll(li); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => closeAll(), 160); });
      btn.addEventListener('click', (e) => {
        if (btn.tagName === 'A' && li.classList.contains('is-open')) return; // second tap follows the link
        e.preventDefault();
        li.classList.contains('is-open') ? closeAll() : open();
      });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('click', (e) => { if (!e.target.closest('.wos-nav')) closeAll(); });
  }

  // ---------- Drawer + search
  function initDrawer() {
    const drawer = $('#wos-drawer');
    if (!drawer) return;
    const set = (open) => {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      $$('[data-wos-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
      if (open) drawer.querySelector('button, a')?.focus();
    };
    $$('[data-wos-drawer-open]').forEach((b) => b.addEventListener('click', () => set(true)));
    $$('[data-wos-drawer-close]', drawer).forEach((b) => b.addEventListener('click', () => set(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); });
  }
  function initSearch() {
    const panel = $('#wos-search');
    if (!panel) return;
    $$('[data-wos-search]').forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      const open = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('input')?.focus();
    }));
  }

  // ---------- Rails: arrow buttons
  function initRails() {
    $$('[data-wos-rail-prev], [data-wos-rail-next]').forEach((btn) => {
      const rail = document.getElementById(btn.getAttribute('aria-controls'));
      if (!rail) return;
      btn.addEventListener('click', () => {
        const dir = btn.hasAttribute('data-wos-rail-next') ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  // ---------- Flavour finder: filter cards by data-flavours
  function initFinder() {
    $$('[data-wos-finder]').forEach((root) => {
      const chips = $$('[data-flavour]', root);
      const cards = $$('[data-flavours]', root);
      const empty = $('[data-wos-finder-empty]', root);
      const max = Number(root.dataset.max || 8);
      const apply = (key) => {
        let shown = 0;
        cards.forEach((c) => {
          const ok = key === 'all' || c.dataset.flavours.split(' ').includes(key);
          const show = ok && shown < max;
          c.hidden = !show;
          if (show) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        chips.forEach((ch) => ch.setAttribute('aria-pressed', String(ch.dataset.flavour === key)));
      };
      chips.forEach((ch) => ch.addEventListener('click', () => apply(ch.dataset.flavour)));
      apply('all');
    });
  }

  // ---------- Experiences: book for me / give as a gift
  function initModeToggle() {
    $$('[data-wos-mode]').forEach((root) => {
      const btns = $$('[data-set-mode]', root);
      btns.forEach((b) => b.addEventListener('click', () => {
        root.dataset.mode = b.dataset.setMode;
        btns.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      }));
    });
  }

  // ---------- Quick add: Shopify AJAX cart, then refresh Dawn's drawer + bubble
  async function quickAdd(btn) {
    const id = btn.dataset.variantId;
    if (!id) return;
    btn.classList.add('is-loading');
    const label = btn.innerHTML;
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = ['cart-drawer', 'cart-icon-bubble'];
      const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Could not add');
      btn.classList.add('is-added');
      btn.innerHTML = '✓ Added';
      if (drawer && typeof drawer.renderContents === 'function') {
        const item = data.items ? data.items[0] : data;
        drawer.renderContents({ ...item, sections: data.sections });
        drawer.classList.remove('is-empty');
      } else {
        updateCount();
      }
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'wos-quick-add', cartData: data });
      setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = label; }, 2200);
    } catch (err) {
      btn.innerHTML = 'Try again';
      setTimeout(() => { btn.innerHTML = label; }, 2200);
    } finally {
      btn.classList.remove('is-loading');
    }
  }
  async function updateCount() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      $$('[data-wos-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (_) { /* offline or preview */ }
  }
  function initQuickAdd() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wos-add]');
      if (!btn) return;
      e.preventDefault();
      quickAdd(btn);
    });
    if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateCount);
  }

  // ---------- Book a table: hand the choice to the hub's booking page
  function initTableForm() {
    $$('[data-wos-table-form]').forEach((form) => {
      const date = form.querySelector('[name="date"]');
      if (date && !date.value) {
        const d = new Date();
        date.value = d.toISOString().slice(0, 10);
        date.min = date.value;
      }
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const url = new URL(form.action);
        new FormData(form).forEach((v, k) => { if (v) url.searchParams.set(k, v); });
        url.searchParams.set('utm_source', 'website');
        url.searchParams.set('utm_medium', form.dataset.utmMedium || 'homepage');
        window.location.href = url.toString();
      });
    });
  }

  // ---------- Countdown to the next live event / dispatch cut-off
  function initCountdowns() {
    $$('[data-wos-countdown]').forEach((el) => {
      const end = new Date(el.dataset.wosCountdown).getTime();
      if (!end) return;
      const tick = () => {
        const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
        el.textContent = d > 0 ? `${d}d ${h}h` : `${h}h ${m}m`;
      };
      tick();
      setInterval(tick, 30000);
    });
  }


  // ---------- Product page: gallery, options, voucher delivery, add to bag
  function initPdp() {
    $$('[data-wos-pdp]').forEach((root) => {
      const stage = $('[data-wos-stage]', root);
      $$('[data-wos-thumb]', root).forEach((t) => t.addEventListener('click', () => {
        const img = stage && stage.querySelector('img:not(.wos-bot__p)');
        if (!img) return;
        img.src = t.dataset.wosThumb; img.removeAttribute('srcset');
        const cutout = t.dataset.cutout === 'true';
        img.classList.toggle('is-cutout', cutout);
        stage.classList.toggle('wos-pdp__stage--cutout', cutout);
        $$('[data-wos-thumb]', root).forEach((x) => x.classList.toggle('is-active', x === t));
      }));

      const form = $('[data-wos-product-form]', root);
      if (!form) return;
      const idInput = $('[data-wos-variant-id]', form);
      const addBtn = $('[data-wos-add-btn]', form);
      const addLabel = $('[data-wos-add-label]', form);
      const price = $('[data-wos-price]', root);
      const points = $('[data-wos-points]', root);
      const variantsEl = $('[data-wos-variants]', form);
      const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      const money = (c) => '£' + (c / 100).toFixed(2).replace(/\.00$/, '');

      const pickVariant = () => {
        const chosen = $$('[data-wos-option]', form).map((fs) => (fs.querySelector('input:checked') || {}).value);
        const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
        if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        if (price) price.textContent = money(v.price);
        if (points) points.textContent = Math.floor(v.price / 100);
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      };
      $$('[data-wos-option] input', form).forEach((i) => i.addEventListener('change', pickVariant));

      $$('[data-wos-qty]', form).forEach((b) => b.addEventListener('click', () => {
        const q = form.querySelector('[name="quantity"]');
        q.value = Math.max(1, Math.min(99, (Number(q.value) || 1) + Number(b.dataset.wosQty)));
      }));

      // Voucher: email (fields shown) or printed card (+£3 add-on, no email fields)
      const vbox = $('[data-wos-voucher]', form);
      const vdelivery = $('[data-wos-voucher-delivery]', form);
      const vfields = $('[data-wos-voucher-email]', form);
      const vmode = () => {
        if (!vbox) return 'email';
        const c = vbox.querySelector('input[name="wos-voucher-mode"]:checked') || vbox.querySelector('input[data-mode]:checked');
        return c ? (c.dataset.mode || c.value) : 'email';
      };
      const syncVoucher = () => {
        const m = vmode();
        if (vfields) vfields.hidden = m !== 'email';
        if (vdelivery) vdelivery.value = m === 'print' ? 'Printed card (posted)' : 'Email';
      };
      if (vbox) { vbox.addEventListener('change', syncVoucher); syncVoucher(); }

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const err = $('[data-wos-form-error]', form);
        if (err) err.hidden = true;
        if (!form.reportValidity()) return;
        const fd = new FormData(form);
        const properties = {};
        for (const [k, v] of fd.entries()) {
          const m = k.match(/^properties\[(.+)\]$/);
          if (m && v !== '') properties[m[1]] = v;
        }
        const qty = Number(fd.get('quantity') || 1);
        const items = [{ id: Number(idInput.value), quantity: qty, properties }];
        if (vbox && vmode() === 'print') {
          const opt = vbox.querySelector('input[name="wos-voucher-mode"][value="print"]');
          ['Recipient name', 'Recipient email', 'Message', 'Send on'].forEach((k) => delete properties[k]);
          if (opt && opt.dataset.addonId) items.push({ id: Number(opt.dataset.addonId), quantity: qty, properties: { 'For voucher': form.dataset.productTitle || '' } });
        }
        addBtn.disabled = true; const label = addLabel.textContent; addLabel.textContent = 'Adding…';
        try {
          const drawer = document.querySelector('cart-drawer');
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
          addLabel.textContent = '✓ Added';
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents({ ...(data.items ? data.items[0] : data), sections: data.sections });
            drawer.classList.remove('is-empty');
          } else { updateCount(); }
          if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'wos-product-form', cartData: data });
          setTimeout(() => { addLabel.textContent = label; addBtn.disabled = false; }, 1800);
        } catch (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
          addLabel.textContent = label; addBtn.disabled = false;
        }
      });
    });
  }


  // ---------- Trade enquiry: two steps → Hub (account manager + Trade CRM), Shopify form as fallback
  function initTradeForm() {
    $$('[data-wos-trade-form]').forEach((form) => {
      if (form.dataset.wosReady) return; form.dataset.wosReady = '1';
      const steps = $$('[data-step]', form);
      const show = (n) => steps.forEach((st) => { st.hidden = st.dataset.step !== String(n); });
      const card = form.closest('.wos-te__card');
      const done = card && $('[data-te-done]', card);
      const err = $('[data-te-error]', form);
      const interests = $('[data-interests]', form);

      // Preselect business type from ?type=pub (links on the segment cards)
      const qs = new URLSearchParams(location.search);
      const want = qs.get('type');
      if (want) { const r = form.querySelector(`[data-type-key="${CSS.escape(want)}"]`); if (r) r.checked = true; }
      const wantIntent = qs.get('intent');
      if (wantIntent) { const r = form.querySelector(`[data-intent="${CSS.escape(wantIntent)}"]`); if (r) r.checked = true; }
      const intentNow = () => (form.querySelector('[data-intent]:checked') || {}).dataset?.intent || 'details';
      const syncIntent = () => {
        const acct = intentNow() === 'account';
        $$('button[type="submit"]', form).forEach((b) => { if (!b.dataset.label) b.dataset.label = b.textContent; b.textContent = acct ? (b.classList.contains('wos-btn--ghost') ? 'Skip to application' : 'Continue to account application') : b.dataset.label; });
      };
      form.addEventListener('change', (e) => { if (e.target.matches('[data-intent]')) syncIntent(); });
      syncIntent();

      $('[data-next]', form)?.addEventListener('click', () => {
        const step1 = $('[data-step="1"]', form);
        const bad = $$('input, select, textarea', step1).find((i) => !i.checkValidity());
        if (bad) { bad.reportValidity(); return; }
        show(2); form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      $('[data-back]', form)?.addEventListener('click', () => show(1));
      form.addEventListener('change', () => {
        if (interests) interests.value = $$('input[name="interest"]:checked', form).map((i) => i.value).join(', ');
      });

      form.addEventListener('submit', async (e) => {
        if (interests) interests.value = $$('input[name="interest"]:checked', form).map((i) => i.value).join(', ');
        const endpoint = form.dataset.endpoint;
        if (!endpoint) return; // plain Shopify contact form
        e.preventDefault();
        if (err) err.hidden = true;
        const step1 = $('[data-step="1"]', form);
        const bad = $$('input, select, textarea', step1).find((i) => !i.checkValidity());
        if (bad) { show(1); bad.reportValidity(); return; }
        const fd = new FormData(form);
        const get = (k) => (fd.get(`contact[${k}]`) || '').toString().trim();
        if (get('Company website confirmation')) { if (done) { form.hidden = true; done.hidden = false; } return; } // honeypot
        const params = new URLSearchParams(location.search);
        const payload = {
          intent: intentNow(),
          business_type: get('Business type'), business_name: get('Company name'), contact_name: get('name'),
          email: get('email'), phone: get('phone'), postcode: get('Postcode'), website: get('Website'),
          interests: get('Products of interest'), expected_first_order: get('Expected initial order'),
          sites: get('Number of sites'), samples: get('Samples required'), visit: get('Trade visit required'),
          message: get('body'), trade_news: get('Trade news opt-in') === 'Yes',
          source_url: location.href, referrer: document.referrer,
          utm: { source: params.get('utm_source'), medium: params.get('utm_medium'), campaign: params.get('utm_campaign') },
        };
        const btns = $$('button[type="submit"]', form); btns.forEach((b) => { b.disabled = true; });
        try {
          const ctrl = new AbortController(); const t = setTimeout(() => ctrl.abort(), 12000);
          const res = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl.signal });
          clearTimeout(t);
          if (!res.ok) throw new Error('hub ' + res.status);
          const data = await res.json().catch(() => ({}));
          if (done) {
            if (data.existing) {
              $('[data-te-done-title]', done).textContent = 'Welcome back!';
              $('[data-te-done-text]', done).textContent = `You already have a trade account with us${data.owner_name ? `, and ${data.owner_name} has your message` : ''}. You can order and download POS in the trade portal.`;
              $('[data-te-portal]', done).hidden = false;
            } else if (payload.intent === 'account') {
              $('[data-te-done-title]', done).textContent = 'Great, one more step';
              $('[data-te-done-text]', done).textContent = `We've saved your details${data.owner_name ? ` and let ${data.owner_name}, your account manager, know` : ''}. Next, complete the short trade account application.`;
              if (data.application_url) {
                const a = $('[data-te-apply]', done); a.href = data.application_url; a.hidden = false;
                setTimeout(() => { location.href = data.application_url; }, 2500);
              }
            } else if (data.owner_name) {
              $('[data-te-done-text]', done).textContent = `${data.owner_name}, your account manager, will be in touch soon with prices and more details.`;
            }
            form.hidden = true; done.hidden = false; done.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          if (window.dataLayer) window.dataLayer.push({ event: 'trade_enquiry', business_type: payload.business_type });
        } catch (ex) {
          // Hub unreachable: fall back to the Shopify contact form so the enquiry still arrives by email
          HTMLFormElement.prototype.submit.call(form);
        } finally {
          btns.forEach((b) => { b.disabled = false; });
        }
      });
    });
  }


  // ---------- Venue hire enquiry: two steps; sent to the Events app by wah-app-enquiry.js
  function initVenueForm() {
    $$('[data-wos-venue-form]').forEach((form) => {
      if (form.dataset.wosReady) return; form.dataset.wosReady = '1';
      const steps = $$('[data-step]', form);
      const show = (n) => steps.forEach((st) => { st.hidden = st.dataset.step !== String(n); });
      const want = new URLSearchParams(location.search).get('occasion');
      if (want) {
        const key = want.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        const r = $$('[data-occasion]', form).find((i) => i.dataset.occasion === key || i.dataset.occasion.startsWith(key));
        if (r) r.checked = true;
      }
      // Join ticked boxes into their hidden contact[...] field as they change, so whichever
      // script sends the form reads the up-to-date value.
      const join = () => $$('[data-join]', form).forEach((h) => {
        h.value = $$(`input[name="${h.dataset.join}"]:checked`, form).map((i) => i.value).join(', ');
      });
      form.addEventListener('change', join);
      $('[data-next]', form)?.addEventListener('click', () => {
        const bad = $$('input, select, textarea', $('[data-step="1"]', form)).find((i) => !i.checkValidity());
        if (bad) { bad.reportValidity(); return; }
        show(2); form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      $('[data-back]', form)?.addEventListener('click', () => show(1));
    });
  }

  // ---------- Parliament join popup: posts to the Hub, which makes and emails a 10% code
  function initJoinPopup() {
    const root = $('[data-wos-join]');
    if (!root || root.dataset.wosReady) return; root.dataset.wosReady = '1';
    const store = {
      get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } },
    };
    if (store.get('wos-join') === 'joined') return;
    const dialog = $('[data-wos-join-dialog]', root);
    const scrim = $('.wos-join__scrim', root);
    const form = $('[data-wos-join-form]', root);
    const done = $('[data-wos-join-done]', root);
    const err = $('[data-wos-join-err]', root);
    let lastFocus = null;

    const open = () => {
      if (!dialog.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false; scrim.hidden = false; dialog.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      setTimeout(() => $('input[name="first_name"]', dialog)?.focus(), 50);
    };
    const close = () => {
      scrim.hidden = true; dialog.hidden = true;
      document.documentElement.style.overflow = '';
      if (!done.hidden) { root.hidden = true; return; }
      store.set('wos-join-closed', String(Date.now()));
      lastFocus?.focus?.();
    };
    $('[data-wos-join-open]', root).addEventListener('click', open);
    $$('[data-wos-join-close]', root).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !dialog.hidden) close(); });

    // Wait for the age gate, then show the pill; open the popup after a delay or half a page scrolled
    // unless it was closed in the last 14 days.
    const ageOk = () => store.get('whatahoot-age-confirmed') === 'yes' || !$('[data-wah-age-gate]:not([hidden])');
    const closedAt = Number(store.get('wos-join-closed') || 0);
    const snoozed = Date.now() - closedAt < 14 * 864e5;
    const start = () => {
      root.hidden = false;
      if (snoozed) return;
      let fired = false;
      const fire = () => { if (fired) return; fired = true; window.removeEventListener('scroll', onScroll); open(); };
      const onScroll = () => { if (scrollY > (document.body.scrollHeight - innerHeight) * 0.5) fire(); };
      setTimeout(fire, Number(root.dataset.delay || 8) * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    };
    if (ageOk()) start();
    else {
      const wait = setInterval(() => { if (ageOk()) { clearInterval(wait); start(); } }, 700);
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      err.hidden = true;
      // Full name typed into the first name box ("Ethan Crown"): move the surname into its own box
      const firstInput = $('input[name="first_name"]', form);
      const lastInput = $('input[name="last_name"]', form);
      if (lastInput && !lastInput.value.trim() && /\s/.test(firstInput.value.trim())) {
        const parts = firstInput.value.trim().split(/\s+/);
        firstInput.value = parts.shift(); lastInput.value = parts.join(' ');
      }
      const bad = $$('input[required]', form).find((i) => !i.checkValidity());
      if (bad) { bad.reportValidity(); return; }
      const fd = new FormData(form);
      if (fd.get('website')) return; // honeypot
      const params = new URLSearchParams(location.search);
      const payload = {
        first_name: String(fd.get('first_name') || '').trim(),
        last_name: String(fd.get('last_name') || '').trim(),
        email: String(fd.get('email') || '').trim().toLowerCase(),
        confirmed_18: fd.get('confirmed_18') === 'on',
        marketing_opt_in: fd.get('marketing_opt_in') === 'on',
        source: 'website-popup', source_url: location.href, referrer: document.referrer,
        shopify_customer_id: window.ShopifyAnalytics?.meta?.page?.customerId || null,
        utm: { source: params.get('utm_source'), medium: params.get('utm_medium'), campaign: params.get('utm_campaign') },
      };
      const btn = $('button[type="submit"]', form); btn.disabled = true;
      const title = $('[data-wos-join-done-title]', done);
      const text = $('[data-wos-join-done-text]', done);
      try {
        const ctrl = new AbortController(); const t = setTimeout(() => ctrl.abort(), 12000);
        const res = await fetch(root.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl.signal });
        clearTimeout(t);
        const data = await res.json().catch(() => ({}));
        if (res.status === 400 && data.error) { err.textContent = data.error; err.hidden = false; return; }
        if (!res.ok) throw new Error('hub ' + res.status);
        if (data.card_url) $('[data-wos-join-card]', done).href = data.card_url;
        if (data.existing && data.already_claimed) {
          // Already a member (joined at the till, on the loyalty site, or used their popup code): the 10% is
          // for new members, so the Hub adds a thank-you of points instead (once) and emails them.
          const kicker = $('[data-wos-join-done-kicker]', done);
          if (kicker) kicker.textContent = 'Thanks for being a member';
          title.textContent = 'This offer is for new members only';
          text.textContent = data.points_added
            ? `But we've added ${data.points_added} points to your card as a thank you!`
            : "You're already part of the Parliament. Your card has your points and treats.";
        } else if (data.existing) {
          title.textContent = `Welcome back${payload.first_name ? ', ' + payload.first_name : ''}`;
          text.textContent = `You're already in the Parliament, so we've sent your 10% code to ${payload.email} again.`;
        } else {
          text.textContent = `Your 10% code is on its way to ${payload.email}. It's also saved on your Parliament card.`;
        }
      } catch (ex) {
        // Hub unreachable: keep the lead as a Shopify customer so the team can send the code
        const body = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': payload.email, 'contact[first_name]': payload.first_name, 'contact[last_name]': payload.last_name, 'contact[tags]': 'newsletter,parliament-popup' });
        await fetch('/contact', { method: 'POST', body }).catch(() => {});
        text.textContent = `Thanks${payload.first_name ? ', ' + payload.first_name : ''}! We've got your details and your 10% code will follow by email shortly.`;
      } finally {
        btn.disabled = false;
      }
      store.set('wos-join', 'joined');
      form.hidden = true; done.hidden = false; done.focus();
      if (window.dataLayer) window.dataLayer.push({ event: 'parliament_join', source: 'website-popup' });
    });
  }

  // ---------- Reveal on scroll
  function initReveal() {
    const els = $$('.wos-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }

  function init() {
    if ($('.wos-dock')) document.body.classList.add('wos-has-dock');
    initNav(); initDrawer(); initSearch(); initRails(); initFinder(); initModeToggle();
    initQuickAdd(); initPdp(); initTradeForm(); initVenueForm(); initTableForm(); initCountdowns(); initJoinPopup(); initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
